import { AutoFocusDirective } from './auto-focus.directive';
import { AutogrowModule } from './autogrow/autogrow.module';
import { CommonModule } from '@angular/common';
import { FitImgInContainerDirective } from './widget-directives/fit-img-in-container.directive';
import { NgModule } from '@angular/core';
import { ResizedDirective } from './rx-resize-event/resized.directive';
import { RxAspectRatioDirective } from './rx-aspect-ratio.directive';
import { RxBusyComponent } from './rx-busy/rx-busy/rx-busy.component';
import { RxBusyDirective } from './rx-busy/rx-busy.directive';
import { RxIconModule } from '@nrwl/rx-icon';
import { SetContainerHeightByAspectRatioDirective } from './widget-directives/set-container-height-by-aspect-ratio.directive';
import { TooltipDirective } from './rx-tooltip/rx-tooltip.directive';
import { RxCharactersDownCounterDirective } from './rx-characters-down-counter/rx-characters-down-counter.directive';
import { RxCurrencyFormatterDirective } from './rx-currency-formatter/rx-currency-formatter.directive';
import { RxBadgeIconDirective } from './rx-badge-icon/rx-badge-icon.directive';
import { RxHasFeatureDirective } from './rx-has-feature.directive';
import { InfiniteScrollTriggerDirective } from './infinite-scroll-trigger.directive';

@NgModule({
  imports: [
    CommonModule,
    AutogrowModule,
    RxIconModule,
    AutoFocusDirective,
    RxAspectRatioDirective,
    ResizedDirective,
    SetContainerHeightByAspectRatioDirective,
    FitImgInContainerDirective,
    TooltipDirective,
    RxBusyDirective,
    RxBusyComponent,
    RxCharactersDownCounterDirective,
    RxCurrencyFormatterDirective,
    RxBadgeIconDirective,
    RxHasFeatureDirective,
    InfiniteScrollTriggerDirective,
  ],
  exports: [
    AutogrowModule,
    AutoFocusDirective,
    RxAspectRatioDirective,
    ResizedDirective,
    SetContainerHeightByAspectRatioDirective,
    FitImgInContainerDirective,
    TooltipDirective,
    RxBusyDirective,
    RxCharactersDownCounterDirective,
    RxCurrencyFormatterDirective,
    RxBadgeIconDirective,
    RxHasFeatureDirective,
    InfiniteScrollTriggerDirective,
  ],
})
export class RxDirectivesModule {}
